/* eslint-disable @wyz/module/no-relative-import */
import { ConfirmationProvider, ThemeProvider, ToastProvider } from '@wyz/ui';
import { QueryClient, QueryClientProvider } from '@wyz/utils';
import * as React from 'react';
import { BrowserRouter } from 'react-router';
import {
  AnalyticsProvider,
  AuthChecker,
  AuthProvider,
  ConfigProvider,
  DatatableProvider,
  MatomoTrackingProvider,
  I18nProvider,
  LocaleProvider,
  LoggerProvider,
  useConfig,
} from '~/common/context';
import { shouldRetryQuery } from '~/common/helpers';

import AppRouter from './app-router';
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: shouldRetryQuery,
    },
  },
});

const ConfiguredApp = () => {
  const { routingBasename } = useConfig();

  // force redirect to routingBasename if the user, intentionally or not, lands on a path outside of it (in our case / , or /onboarding)
  React.useEffect(() => {
    if (
      routingBasename &&
      !window.location.pathname.startsWith(routingBasename)
    ) {
      const currentPath =
        window.location.pathname === '/' ? '' : window.location.pathname;
      const newPath = `${routingBasename}${currentPath}${window.location.search}${window.location.hash}`;
      window.location.replace(newPath);
    }
  }, [routingBasename]);

  if (
    routingBasename &&
    !window.location.pathname.startsWith(routingBasename)
  ) {
    return null;
  }

  return (
    <LoggerProvider>
      <BrowserRouter basename={routingBasename}>
        <ConfirmationProvider>
          <ThemeProvider>
            <ToastProvider>
              <AnalyticsProvider>
                <AuthProvider>
                  <MatomoTrackingProvider>
                    <LocaleProvider>
                      <I18nProvider>
                        <AuthChecker>
                          <DatatableProvider>
                            <React.Suspense fallback={null}>
                              <AppRouter />
                            </React.Suspense>
                          </DatatableProvider>
                        </AuthChecker>
                      </I18nProvider>
                    </LocaleProvider>
                  </MatomoTrackingProvider>
                </AuthProvider>
              </AnalyticsProvider>
            </ToastProvider>
          </ThemeProvider>
        </ConfirmationProvider>
      </BrowserRouter>
    </LoggerProvider>
  );
};

const Main = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider>
        <ConfiguredApp />
      </ConfigProvider>
    </QueryClientProvider>
  );
};

export default Main;
